
  import createMeisterIcons from '../src/createMeisterIcons';

  const Nav = createMeisterIcons("nav", [["g",{"clip-path":"url(#a)","key":"bfc93afcd8ad1113a547136d51ab5fdc40a066f8","fillRule":"evenodd","clipRule":"evenodd"}],["defs",{"key":"4722e060e69a581c86a9a2a35e2bf4c72e941194","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Nav
  